import { render, staticRenderFns } from "./VrPage.vue?vue&type=template&id=a60e8e1a&scoped=true"
import script from "./VrPage.vue?vue&type=script&lang=js"
export * from "./VrPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60e8e1a",
  null
  
)

export default component.exports